module.exports = __webpack_public_path__ + "static/media/backdash.d438367e.png";